import React from 'react';
import { TypedMemo } from '../common/types';
import styles from './TeamAcceptHeading.module.scss';

interface TeamAcceptHeadingProps {
  title: string;
  lead: string;
  /** The title names another person (an email): keep it out of the Clarity session replay. */
  isTitleMasked?: boolean;
  /** The lead names another person (an email): keep it out of the Clarity session replay. */
  isLeadMasked?: boolean;
}

/** The accept card's heading: one bold sentence, then a quieter line. */
const TeamAcceptHeadingComponent: React.FC<TeamAcceptHeadingProps> = ({
  title,
  lead,
  isTitleMasked = false,
  isLeadMasked = false,
}) => (
  <div className="mb-3">
    <h1 className={`h3 mb-2 ${styles.title}`} data-clarity-mask={isTitleMasked ? 'true' : undefined}>
      {title}
    </h1>
    <p className={`mb-0 ${styles.lead}`} data-clarity-mask={isLeadMasked ? 'true' : undefined}>
      {lead}
    </p>
  </div>
);

export const TeamAcceptHeading = TypedMemo(TeamAcceptHeadingComponent);
